<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="well-title">
        <div class="col-md-12">{{ !loading ? (isEditMode ? "Edit" : "Create") : "" }} Scan Directory</div>
    </div>
    <div class="col-md-12">
        <a class="back-link" routerLink="/configure/scandirectory">Back to Scan Directories</a>
    </div>
    <div class="col-md-12 well-content">
        @if (successMsg) {
            <div class="alert alert-success">{{ successMsg }}</div>
        }
        @if (errorMsg) {
            <div class="alert alert-danger">{{ errorMsg }}</div>
        }
        <div class="panel panel-default">
            <div class="panel-heading">General</div>
            <div class="panel-body">
                <form #frm="ngForm" class="form-horizontal">
                    <div class="form-group">
                        <label for="scanDirPath" class="col-md-2 control-label"
                            >Name <span style="color: red">*</span></label
                        >
                        <div class="col-md-6">
                            <input
                                name="scanDirPath"
                                type="text"
                                required
                                maxlength="255"
                                #pathMdl="ngModel"
                                class="form-control"
                                [(ngModel)]="scanDirectory.ScanDirectoryPath" />
                            @if (pathMdl.touched && pathMdl.invalid) {
                                <span class="text-danger">Name is required</span>
                            }
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="scanDirSetupType" class="col-md-2 control-label"
                            >Setup Type <span style="color: red">*</span></label
                        >
                        <div class="col-md-6">
                            <select
                                name="scanDirSetupType"
                                class="form-control"
                                required
                                #setupMdl="ngModel"
                                [(ngModel)]="scanDirectory.ScanSetupType"
                                (ngModelChange)="setupTypeChange()">
                                <option [ngValue]="0">All Pages One Document</option>
                                <option [ngValue]="1">Each Page One Document</option>
                                <option [ngValue]="2">BarcodeSeparated</option>
                                <option [ngValue]="3">Nothing</option>
                                <option [ngValue]="4">Zonal OCR</option>
                                @if (aiEnabled) {
                                    <option [ngValue]="5">AI OCR</option>
                                }
                            </select>
                            @if (setupMdl.touched && setupMdl.invalid) {
                                <span class="text-danger">Setup type is required</span>
                            }
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="scanDirDocType" class="col-md-2 control-label"
                            >Document Type
                            @if (!aiEnabled || scanDirectory.ScanSetupType !== 5) {
                                <span style="color: red">*</span>
                            }
                        </label>
                        <div class="col-md-6">
                            @if (!aiEnabled || scanDirectory.ScanSetupType !== 5) {
                                <select
                                    name="scanDirDocType"
                                    class="form-control"
                                    required
                                    #docMdl="ngModel"
                                    [(ngModel)]="scanDirectory.ScanDocumentType"
                                    (ngModelChange)="docTypeChange()">
                                    @for (doc of documentTypes; track doc) {
                                        <option [ngValue]="doc.ID">{{ doc.Name }}</option>
                                    }
                                </select>
                                @if (docMdl.touched && docMdl.invalid) {
                                    <span class="text-danger"> Document Type is required </span>
                                }
                            } @else {
                                <input
                                    type="hidden"
                                    name="hiddenScanDirDocType"
                                    [(ngModel)]="scanDirectory.ScanDocumentType" />
                                <input
                                    name="scanDirDocType"
                                    type="text"
                                    class="form-control"
                                    value="Automatically detected by AI OCR"
                                    readonly />
                            }
                        </div>
                    </div>
                    @if (aiEnabled && scanDirectory.ScanSetupType === 5 && showsAiPrompt) {
                        <div class="form-group">
                            <label for="scanDirSetupType" class="col-md-2 control-label"
                                ><i class="fa-solid fa-wand-magic-sparkles"></i>&nbsp;AI Prompt</label
                            >
                            <div class="col-md-6">
                                <textarea
                                    style="resize: vertical"
                                    rows="7"
                                    [maxlength]="1024"
                                    #promptMdl="ngModel"
                                    name="scanDirAiPrompt"
                                    class="form-control"
                                    [(ngModel)]="scanDirectory.AiPrompt">
                                </textarea>
                                @if (promptMdl.touched && promptMdl.invalid && promptMdl?.errors?.maxlength) {
                                    <span class="text-danger">Prompt must be less than 1024 characters</span>
                                }
                            </div>
                        </div>
                    }
                </form>
            </div>
        </div>
        @if (aiEnabled && scanDirectory.ScanSetupType === 5 && showsKeywordHints) {
            <div class="panel panel-default">
                <div class="panel-heading"><i class="fa-solid fa-wand-magic-sparkles"></i>&nbsp;AI Keyword Hints</div>
                <div class="panel-body">
                    <form #keywordForm="ngForm">
                        <table
                            id="keywords"
                            cellspacing="0"
                            cellpadding="4"
                            width="100%"
                            class="keywords one-column-modify">
                            <tbody>
                                <tr>
                                    <th width="300">Keyword</th>
                                    <th>Hint</th>
                                    <th></th>
                                </tr>
                                @for (hint of scanDirectory.AiHints; track hint; let i = $index) {
                                    <tr>
                                        <td>{{ getKeywordName(hint.Id) }}</td>
                                        <td>{{ hint.Hint }}</td>
                                        <td>
                                            <img
                                                class="hand"
                                                (click)="removeKeyword(i)"
                                                alt="Remove"
                                                src="assets/images/Remove.png" />
                                        </td>
                                    </tr>
                                }
                                <tr id="metaDataAddRow">
                                    <td width="300" style="vertical-align: baseline">
                                        <select
                                            name="newKeywordId"
                                            [(ngModel)]="newKeyword.Id"
                                            class="form-control"
                                            required
                                            #keyMdl="ngModel"
                                            id="metaDataDefinitionList">
                                            @for (keyword of typeKeywords; track keyword) {
                                                <option [ngValue]="keyword.ID">
                                                    {{ keyword.Name }}
                                                </option>
                                            }
                                        </select>
                                        @if (keyMdl.touched && keyMdl.invalid) {
                                            <span class="text-danger">Keyword is required</span>
                                        }
                                    </td>
                                    <td style="vertical-align: baseline">
                                        <input
                                            class="form-control"
                                            type="text"
                                            required
                                            [maxlength]="255"
                                            #hintMdl="ngModel"
                                            name="newKeywordValue"
                                            [(ngModel)]="newKeyword.Hint" />
                                        @if (hintMdl.touched && hintMdl.invalid && hintMdl.errors?.required) {
                                            <span class="text-danger">Hint is required</span>
                                        }
                                        @if (hintMdl.touched && hintMdl.errors?.maxlength) {
                                            <span class="text-danger">Hint must be less than 255 characters.</span>
                                        }
                                    </td>
                                    <td style="vertical-align: baseline">
                                        <img
                                            class="hand"
                                            (click)="addKeyword(keywordForm)"
                                            alt="Add"
                                            src="assets/images/Add.png" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </form>
                </div>
            </div>
        }

        <button class="btn btn-default" (click)="save(frm)">Save Changes</button>
        @if (scanDirectory.ScanDirectoryID) {
            <button class="btn btn-danger pull-right" (click)="remove()">Delete Scan Directory</button>
        }
    </div>
</div>
